import React from 'react';

const Routes = () => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">Route Management</h2>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">Route optimization and management interface will be displayed here.</p>
      </div>
    </div>
  );
};

export default Routes;

